export type FaixaBreakpoint = 'mobile' | 'tablet' | 'desktop' | 'largo';

export interface LayoutGrid {
    colunas: number;
    gutter: number;
    margem: number;
}

export const INICIO_FAIXA: Readonly<Record<FaixaBreakpoint, number>> = {
    mobile: 0,
    tablet: 744,
    desktop: 1280,
    largo: 1728,
};

export const LAYOUT_GRID: Readonly<Record<FaixaBreakpoint, Readonly<LayoutGrid>>> = {
    mobile: { colunas: 2, gutter: 16, margem: 16 },
    tablet: { colunas: 6, gutter: 16, margem: 24 },
    desktop: { colunas: 12, gutter: 16, margem: 112 },
    largo: { colunas: 12, gutter: 16, margem: 112 },
};

/** Folga entre o fim de uma faixa e o início da seguinte, a mesma de `$folga-fim-faixa` no SCSS. */
export const FOLGA_FIM_FAIXA = 0.02;

const FAIXAS = Object.keys(INICIO_FAIXA) as FaixaBreakpoint[];

/**
 * Media query do mixin `ate()` do SCSS, para `matchMedia`. Use-a em vez de comparar `innerWidth` com
 * `INICIO_FAIXA`, para que TypeScript e CSS mudem de faixa na mesma largura.
 * `mediaAte('largo')` não compila porque valeria para todas as larguras.
 */
export function mediaAte(faixa: Exclude<FaixaBreakpoint, 'largo'>): string {
    const seguinte = FAIXAS[FAIXAS.indexOf(faixa) + 1];
    return `(max-width: ${INICIO_FAIXA[seguinte] - FOLGA_FIM_FAIXA}px)`;
}

/**
 * Media query do mixin `a-partir-de()` do SCSS, para `matchMedia`.
 * `mediaAPartirDe('mobile')` não compila porque valeria para todas as larguras.
 */
export function mediaAPartirDe(faixa: Exclude<FaixaBreakpoint, 'mobile'>): string {
    return `(min-width: ${INICIO_FAIXA[faixa]}px)`;
}
